export const API_URL = import.meta.env.VITE_TEST_MODE
  ? "http://0.0.0.0:3000"
  : import.meta.env.VITE_API_URL || "http://localhost:3000";
export const ORY_URL = import.meta.env.VITE_ORY_URL || "http://localhost:4000";
export const ORY_BASE_PATH = import.meta.env.DEV ? "" : ORY_URL;
export const API_TOKEN =
  import.meta.env.VITE_API_TOKEN || "4x1c6fm0icy237879p187wa9y1mmel5i";
export const MS_LOGOUT_URL =
  import.meta.env.VITE_MS_LOGOUT_URL ||
  "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
export const IS_MS_LOGOUT_ENABLED =
  Boolean(import.meta.env.VITE_MS_LOGOUT_URL) ||
  !(import.meta.env.DEV || import.meta.env.VITE_TEST_MODE);
export const TIMEZONE = "Europe/Helsinki";

export const RIGHTS_ROLES_ADMIN = "roles_admin";
export const RIGHTS_STAKEHOLDERS_ADMIN = "stakeholders_admin";
export const RIGHTS_USE_RIGHTS_ADMIN = "users_admin";
export const RIGHTS_USERS_ADMIN = "users_admin";
export const RIGHTS_USER_STORIES_ADMIN = "userStories_admin";
